import api from '../../api/_medicament'

const state = () => ({
    categorie_medicaments: [],
    medicaments: [],
    injections: [],
    consommables: [],
    medicaments_disponibles: [],
    consommables_disponibles: [],
    liste_medicaments_by_categorie: [],
    liste_consommables: [],
})

// getters
const getters = {
        injections: (state) => {
            return state.injections
        },

        medicaments: (state) => {
            return state.medicaments
        },

        categorie_medicaments: (state) => {
            return state.categorie_medicaments
        },

        consommables: (state) => {
            return state.consommables
        },

        medicaments_disponibles: (state) => {
            return state.medicaments_disponibles
        },

        consommables_disponibles: (state) => {
            return state.consommables_disponibles
        },

        liste_medicaments_by_categorie: (state) => {
            return state.liste_medicaments_by_categorie;
        },

        liste_consommables: (state) => {
            return state.liste_consommables
        },
        
    }
    // mutations
const mutations = {
    SET_MEDICAMENTS(state, medicaments) {
        state.medicaments = medicaments
    },

    SET_INJECTIONS(state, injections) {
        state.injections = injections
    },

    SET_CONSOMMABLES(state, consommables) {
        state.consommables = consommables
    },

    SET_CATEGORIE_MEDICAMENTS(state, categorie_medicaments) {
        state.categorie_medicaments = categorie_medicaments
    },

    SET_MEDICAMENTS_DISPONIBLES(state, medicaments) {
        state.medicaments_disponibles = medicaments
    },

    SET_CONSOMMABLES_DISPONIBLES(state, consommables) {
        state.consommables_disponibles = consommables
    },

    SET_LISTE_MEDICAMENTS_BY_CATEGORIE(state, medicaments) {
        state.liste_medicaments_by_categorie = medicaments
    },

    SET_LISTE_CONSOMMABLES(state, consommables) {
        state.liste_consommables = consommables
    },
}

// actions
const actions = {
    getMedicaments({ commit }) {
        api.getMedicaments().then(
            response => {
                commit('SET_MEDICAMENTS', response)
            }
        )
    },

    getCategorieMedicaments({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCategorieMedicaments().then(
                response => {
                    resolve(response)
                    commit('SET_CATEGORIE_MEDICAMENTS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },


    getInjections({ commit }) {
        api.getInjections().then(
            response => {
                commit('SET_INJECTIONS', response)
            }
        )
    },

    getConsommables({ commit }) {
        api.getConsommables().then(
            response => {
                commit('SET_CONSOMMABLES', response)
            }
        )
    },

    getListeMedicamentDisponible({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeMedicamentDisponible().then(
                response => {
                    resolve(response)
                    commit('SET_MEDICAMENTS_DISPONIBLES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeConsommableDisponible({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeConsommableDisponible().then(
                response => {
                    resolve(response)
                    commit('SET_CONSOMMABLES_DISPONIBLES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeMedicamentsParCategorie({commit}, data){
        return new Promise((resolve,reject) => {
            api.getListeMedicamentsParCategorie(data).then(
                response => {
                    commit('SET_LISTE_MEDICAMENTS_BY_CATEGORIE', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeConsommables({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeConsommables().then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_CONSOMMABLES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}